import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthPaths } from './modules/authentication/authentication-routing.module';
import { AuthGuard } from './_helpers/auth.guard';
import { UserPaths } from './modules/user/user-paths';

const routes: Routes = [
  { path: '', redirectTo: AuthPaths.signIn, pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import('./modules/authentication/authentication.module').then(
        (m) => m.AuthenticationModule,
      ),
  },
  {
    path: UserPaths.home,
    loadChildren: () =>
      import('./modules/user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'sales',
    loadChildren: () =>
      import('./modules/sales/sales.module').then((m) => m.SalesModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
